var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './modal.module.css';
import Icon from '../media/icon/Icon';
import { Icons, IconSizes } from '../icons/icons';
import clsx from 'clsx';
var ModalHeader = function (_a) {
    var onRequestClose = _a.onRequestClose, children = _a.children;
    return (_jsxs("div", __assign({ className: clsx(styles.header) }, { children: [children, _jsx("button", __assign({ onClick: onRequestClose, className: styles.button }, { children: _jsx(Icon, { icon: Icons.CROSS, size: IconSizes.S }) }))] })));
};
export default ModalHeader;
